/**
 * Mirrors marabot-api `AnalyticsSummary` (GET /analytics/summary).
 */
export const ANALYTICS_WINDOWS = [7, 30, 90] as const;
export type AnalyticsWindow = (typeof ANALYTICS_WINDOWS)[number];

export interface AnalyticsCount {
    key: string;
    count: number;
}

export interface AnalyticsRecentPost {
    postId: string;
    platform: string;
    postType: string | null;
    mediaKind: string;
    publishedAt: string;
    postUrl: string | null;
    excerpt: string | null;
}

export interface AnalyticsTotals {
    published: number;
    networksUsed: number;
    listingsCovered: number;
    videos: number;
    images: number;
    textOnly: number;
}

export interface AnalyticsSummary {
    window: number;
    start: string;
    end: string;
    timeZone: string;
    totals: AnalyticsTotals;
    byPlatform: AnalyticsCount[];
    byPostType: AnalyticsCount[];
    byMediaKind: AnalyticsCount[];
    perDay: { date: string; count: number }[];
    recent: AnalyticsRecentPost[];
}
